export default __webpack_public_path__ + "static/media/1929.17bed45b.png";